__turbopack_context__.v({
  "childrenContainer": "ExpandySection-module__8aloza__childrenContainer",
  "header": "ExpandySection-module__8aloza__header",
  "headerRight": "ExpandySection-module__8aloza__headerRight",
});
